import React from 'react';
import img from '../../images/giphy.gif'
const PlaceOrder = () => {
    return (
        <div className="text-center">
            <img src={img} alt="" />
        </div>
    );
};

export default PlaceOrder;